import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

/**
 * useCreditPacks(thematiqueId?)
 * Fetches the current user's Pack Booster dashboard.
 * Call `reload()` after a successful purchase or after an AI call that consumed
 * a pack credit, to refresh the counters.
 */
export default function useCreditPacks(thematiqueId = null) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const params = thematiqueId ? { user_thematique_id: thematiqueId } : {};
            const { data: resp } = await api.get('/user/credit-packs.php', { params });
            setData(resp.data || null);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur');
            setData(null);
        }
        setLoading(false);
    }, [thematiqueId]);

    useEffect(() => { load(); }, [load]);

    const offers = data?.offers || [];
    const defaultOffer = offers[0] || null;

    return {
        loading,
        error,
        packs:           data?.packs || [],
        docRemaining:    data?.doc_remaining ?? 0,
        promptRemaining: data?.prompt_remaining ?? 0,
        monoRemaining:   data?.mono_remaining ?? 0,
        // Catalog of available Pack offers (admin-configurable)
        offers,
        defaultOffer,
        // Back-compat shims for callers that used the old shape
        priceEur:        defaultOffer?.price_eur ?? 10,
        content:         defaultOffer
            ? { doc: defaultOffer.doc_credits, mono: defaultOffer.mono_credits }
            : { doc: 30, mono: 200 },
        // Per-thematique lifetime caps (null if no thematiqueId was passed).
        thematiqueCaps:  data?.thematique_caps || null,
        monoCap:         data?.thematique_caps?.mono_cap ?? null,
        monoUsed:        data?.thematique_caps?.mono_used ?? 0,
        reload:          load,
    };
}
